(function () {
  'use strict';

  var STORAGE_KEY = 'pricingMode';
  var VAT_RATE = 1.19;
  var DATA_ATTR = 'data-brutto-cents';
  var NETTO_LABEL_CLASS = 'netto-brutto-vat-label';

  // Known selectors for price elements in Empire v12.3.0
  var KNOWN_SELECTORS = [
    // PDP prices (product-price.liquid)
    '.money[data-price]',
    '.money[data-price-compare]',
    '.money[data-price-min]',
    '.money[data-price-max]',
    '.money[data-price-compare-min]',
    '.money[data-price-compare-max]',
    '.money.price__compare-at--single',
    '.money.price__compare-at--min',
    '.money.price__compare-at--max',
    '.money.price__current--min',
    '.money.price__current--max',
    '.money.price__original',
    // Cart prices
    '.money.cart-item--sale-price',
    '.money.cart-item--discount-price',
    '.money[data-unit-price-amount]',
    // Newer Empire price component
    '.element-text--price',
    // Homepage collection tabs (custom grid)
    '.product-price-cls',
    '[class*="price-template--"]'
  ].join(',');

  // Regex to detect price-like text content
  var PRICE_REGEX = /€[\d.,]+|[\d.,]+\s*€/;

  /**
   * Parse a German-formatted price string to cents.
   * Handles: "83,69 €", "€83,69", "83.69 €", "Ab 83,69 €", etc.
   * Returns integer cents or null if unparseable.
   */
  function parsePriceToCents(text) {
    if (!text) return null;
    // Strip currency symbols, whitespace, "Ab", "ab", sup tags
    var cleaned = text.replace(/<\/?su[pb]>/gi, '').replace(/[€$£\s]/g, '').replace(/^(ab|von)\s*/i, '').trim();
    if (!cleaned) return null;

    // Detect German format: 1.234,56 or 83,69
    // vs English format: 1,234.56 or 83.69
    var lastComma = cleaned.lastIndexOf(',');
    var lastDot = cleaned.lastIndexOf('.');

    var normalized;
    if (lastComma > lastDot) {
      // German: comma is decimal separator
      normalized = cleaned.replace(/\./g, '').replace(',', '.');
    } else if (lastDot > lastComma) {
      // English or dot-decimal
      normalized = cleaned.replace(/,/g, '');
    } else {
      // No decimal separator
      normalized = cleaned.replace(/[.,]/g, '');
    }

    var num = parseFloat(normalized);
    if (isNaN(num)) return null;
    return Math.round(num * 100);
  }

  /**
   * Format cents to German price string: "83,69 €"
   */
  function formatCents(cents) {
    var euros = (cents / 100).toFixed(2);
    // Replace dot with comma for German format
    var parts = euros.split('.');
    var formatted = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1];
    return formatted + '\u00a0\u20ac';
  }

  /**
   * Format cents with superscript decimals (matches Empire's element-text--price-superscript)
   */
  function formatCentsSuperscript(cents) {
    var euros = (cents / 100).toFixed(2);
    var parts = euros.split('.');
    var main = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return '<span>' + main + '</span><sup>' + parts[1] + '</sup>\u00a0\u20ac';
  }

  /**
   * Store brutto price and convert a single element.
   * Handles both single prices and range prices ("€1.799,00 - €2.590,00").
   */
  function convertElement(el, mode) {
    var text = el.textContent || el.innerText || '';
    var isRange = text.indexOf(' - ') !== -1 || text.indexOf(' – ') !== -1;

    if (isRange) {
      convertRangeElement(el, mode);
      return;
    }

    // On first encounter, store the original brutto price
    if (!el.hasAttribute(DATA_ATTR)) {
      var cents = parsePriceToCents(text);
      if (cents === null || cents === 0) return;
      el.setAttribute(DATA_ATTR, cents);
      el.setAttribute('data-brutto-html', el.innerHTML);
    }

    var bruttoCents = parseInt(el.getAttribute(DATA_ATTR), 10);
    if (isNaN(bruttoCents)) return;

    var useSuperscript = el.classList.contains('element-text--price-superscript');

    if (mode === 'netto') {
      var nettoCents = Math.round(bruttoCents / VAT_RATE);
      el.innerHTML = useSuperscript ? formatCentsSuperscript(nettoCents) : formatCents(nettoCents);
    } else {
      // Restore original HTML to preserve any sup tags etc.
      var origHtml = el.getAttribute('data-brutto-html');
      if (origHtml) {
        el.innerHTML = origHtml;
      } else {
        el.innerHTML = useSuperscript ? formatCentsSuperscript(bruttoCents) : formatCents(bruttoCents);
      }
    }
  }

  /**
   * Handle range prices like "€1.799,00 - €2.590,00"
   */
  function convertRangeElement(el, mode) {
    if (!el.hasAttribute('data-brutto-range')) {
      // Store original range text
      el.setAttribute('data-brutto-range', el.textContent || '');
    }

    var original = el.getAttribute('data-brutto-range');
    if (mode === 'brutto') {
      el.textContent = original;
      return;
    }

    // Split on dash, convert each price
    var separator = original.indexOf(' – ') !== -1 ? ' – ' : ' - ';
    var parts = original.split(separator);
    var converted = [];

    for (var i = 0; i < parts.length; i++) {
      var cents = parsePriceToCents(parts[i]);
      if (cents !== null && cents > 0) {
        converted.push(formatCents(Math.round(cents / VAT_RATE)));
      } else {
        converted.push(parts[i].trim());
      }
    }

    el.textContent = converted.join(' - ');
  }

  /**
   * Add or remove "(zzgl. 19% MwSt.)" labels near price containers.
   */
  function updateVatLabels(mode) {
    // Remove existing labels
    var existing = document.querySelectorAll('.' + NETTO_LABEL_CLASS);
    for (var i = 0; i < existing.length; i++) {
      existing[i].parentNode.removeChild(existing[i]);
    }

    if (mode !== 'netto') return;

    // Add labels after main price containers (PDP, Cart, Homepage grids)
    var containers = document.querySelectorAll(
      '.price__current[data-price-container], .cart-item--content-price, .product-price, [class*="product-price-cls"], .product-details-cls'
    );

    for (var j = 0; j < containers.length; j++) {
      // Don't add duplicate labels
      if (containers[j].querySelector('.' + NETTO_LABEL_CLASS)) continue;
      var label = document.createElement('span');
      label.className = NETTO_LABEL_CLASS;
      label.textContent = '(zzgl. 19% MwSt.)';
      containers[j].appendChild(label);
    }
  }

  /**
   * Check if element is a hidden/template price element that should be skipped.
   */
  function isHiddenPrice(el) {
    // Skip Empire hidden price templates
    if (el.closest('[data-compare-price-hidden], [data-compare-price-range-hidden], [data-current-price-hidden], [data-current-price-range-hidden]')) {
      return true;
    }
    // Skip elements that are not visible
    if (el.offsetParent === null && !el.closest('[style*="position: fixed"]')) {
      return true;
    }
    return false;
  }

  /**
   * Convert all prices on the page.
   * Uses known selectors + generic price text scan as fallback.
   */
  function convertAllPrices(mode) {
    var processed = new Set();

    // Pass 1: Known selectors
    var elements = document.querySelectorAll(KNOWN_SELECTORS);
    for (var i = 0; i < elements.length; i++) {
      var el = elements[i];
      if (isHiddenPrice(el)) continue;
      convertElement(el, mode);
      processed.add(el);
    }

    // Pass 2: Generic scan for price-like leaf nodes not yet processed
    // This catches custom sections with non-standard class names
    var candidates = document.querySelectorAll('span, div, p, td, li, strong, b');
    for (var j = 0; j < candidates.length; j++) {
      var cand = candidates[j];
      if (processed.has(cand)) continue;
      // Only leaf nodes or nodes with just text + sup/sub children
      if (cand.querySelector('div, span:not(sup):not(sub), p, a, button')) continue;
      var text = cand.textContent || '';
      if (!PRICE_REGEX.test(text)) continue;
      // Skip toggle bar, labels, and non-price contexts
      if (cand.closest('.netto-brutto-bar, .netto-brutto-vat-label, nav, .site-header, .announcement-bar')) continue;
      if (isHiddenPrice(cand)) continue;
      convertElement(cand, mode);
      processed.add(cand);
    }

    updateVatLabels(mode);
  }

  /**
   * Update toggle button UI state.
   */
  function updateToggleUI(mode) {
    var toggle = document.getElementById('netto-brutto-toggle');
    if (!toggle) return;
    var buttons = toggle.querySelectorAll('.netto-brutto-toggle__btn');
    for (var i = 0; i < buttons.length; i++) {
      var btn = buttons[i];
      var isActive = btn.getAttribute('data-mode') === mode;
      btn.classList.toggle('netto-brutto-toggle__btn--active', isActive);
      btn.setAttribute('aria-checked', isActive ? 'true' : 'false');
    }
  }

  /**
   * Get current mode from localStorage.
   */
  function getMode() {
    try {
      return localStorage.getItem(STORAGE_KEY) || 'brutto';
    } catch (e) {
      return 'brutto';
    }
  }

  /**
   * Set mode in localStorage.
   */
  function setMode(mode) {
    try {
      localStorage.setItem(STORAGE_KEY, mode);
    } catch (e) {
      // localStorage not available
    }
  }

  /**
   * Apply mode: convert prices + update UI.
   */
  function applyMode(mode) {
    convertAllPrices(mode);
    updateToggleUI(mode);
  }

  /**
   * Check if we are on a product page.
   */
  function isProductPage() {
    // Shopify sets meta tag or body class for product pages
    var bodyClasses = document.body.className || '';
    if (/\btemplate-product\b/.test(bodyClasses)) return true;
    // Fallback: check URL pattern
    if (/\/products\//.test(window.location.pathname)) return true;
    // Fallback: check for product-block--price element
    if (document.querySelector('.product-block--price')) return true;
    return false;
  }

  /**
   * Create and inject toggle HTML into PDP price area.
   * DISABLED 2026-05-12: Toggle visuell entfernt — Tax-Hinweis aus
   * custom-pdp-injector.js (zzgl. 19% MwSt. (= XX € inkl.)) reicht aus.
   * Begründung: verwirrend für User (2x MwSt-Wahrnehmung), Toggle-State
   * und Hauptpreis-Anzeige waren nicht synchronisiert.
   */
  function createToggleOnPDP() {
    return;  // EARLY EXIT — Toggle deaktiviert
    if (!isProductPage()) return;

    // Find the price block on PDP
    var priceBlock = document.querySelector('.product-block--price');
    if (!priceBlock) return;

    // Don't create twice
    if (document.getElementById('netto-brutto-toggle')) return;

    var mode = getMode();

    // Build toggle HTML
    var wrapper = document.createElement('div');
    wrapper.className = 'netto-brutto-inline';
    wrapper.id = 'netto-brutto-bar';
    wrapper.innerHTML =
      '<div class="netto-brutto-toggle" id="netto-brutto-toggle" role="radiogroup" aria-label="Preisanzeige">' +
        '<button class="netto-brutto-toggle__btn' + (mode === 'brutto' ? ' netto-brutto-toggle__btn--active' : '') + '" data-mode="brutto" role="radio" aria-checked="' + (mode === 'brutto') + '" type="button">Brutto</button>' +
        '<button class="netto-brutto-toggle__btn' + (mode === 'netto' ? ' netto-brutto-toggle__btn--active' : '') + '" data-mode="netto" role="radio" aria-checked="' + (mode === 'netto') + '" type="button">Netto</button>' +
      '</div>';

    // Insert after the price block
    priceBlock.parentNode.insertBefore(wrapper, priceBlock.nextSibling);
  }

  /**
   * Initialize toggle click handlers.
   */
  function initToggle() {
    // Create toggle on PDP only
    createToggleOnPDP();

    var toggle = document.getElementById('netto-brutto-toggle');
    if (!toggle) return;

    toggle.addEventListener('click', function (e) {
      var btn = e.target.closest('.netto-brutto-toggle__btn');
      if (!btn) return;
      var mode = btn.getAttribute('data-mode');
      if (mode === getMode()) return;
      setMode(mode);
      applyMode(mode);
    });
  }

  /**
   * Observe DOM for dynamically added price elements (AJAX cart, variant changes, etc.)
   */
  function observePriceChanges() {
    if (typeof MutationObserver === 'undefined') return;

    var debounceTimer;
    var observer = new MutationObserver(function () {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function () {
        var mode = getMode();
        if (mode === 'netto') {
          convertAllPrices(mode);
        }
      }, 150);
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  /**
   * Hide variant selectors with only one value (e.g. "Einheitsgröße").
   * CSS :has() handles modern browsers; this is the JS fallback.
   */
  function hideSingleValueOptions() {
    var fieldsets = document.querySelectorAll('.options-selection__radios');
    for (var i = 0; i < fieldsets.length; i++) {
      var values = fieldsets[i].querySelectorAll('.options-selection__option-value');
      if (values.length === 1) {
        fieldsets[i].classList.add('options-selection__radios--single-value');
      }
    }
  }

  /**
   * Boot
   */
  function init() {
    var mode = getMode();
    initToggle();
    applyMode(mode);
    hideSingleValueOptions();
    observePriceChanges();
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
